import KYCPage from './KYCPage';

export default KYCPage;
